import { ReactNode } from 'react';
import { ConfirmModalButtons, ConfirmBody, Hint } from './styles';
import { Dialog } from '@/components-new/Dialog/Dialog';
import { ButtonNew, ButtonVariantType } from '@/components-new/ButtonNew/ButtonNew';

type ConfirmModalType = {
  isOpen: boolean;
  header: ReactNode;
  body?: ReactNode;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  closeText?: ReactNode;
  confirmText?: ReactNode;
  confirmButtonVariant?: ButtonVariantType;
};

type HintInfoType = {
  children: ReactNode;
};

export const ConfirmModalHint = ({ children }: HintInfoType) => {
  return <Hint>{children}</Hint>;
};

export const ConfirmModal = ({
  isOpen,
  header,
  body,
  onClose,
  onConfirm,
  isLoading,
  closeText,
  confirmText,
  confirmButtonVariant,
}: ConfirmModalType) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} header={header}>
      {body && <ConfirmBody>{body}</ConfirmBody>}

      <ConfirmModalButtons>
        <ButtonNew variant='secondary' onClick={onClose}>
          {closeText || 'Close'}
        </ButtonNew>
        <ButtonNew variant={confirmButtonVariant} onClick={onConfirm} isLoading={isLoading}>
          {confirmText || 'Yes'}
        </ButtonNew>
      </ConfirmModalButtons>
    </Dialog>
  );
};
